import { styled } from 'shared/ui';

export const SpinnerWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'wait',
});
